module.exports = __webpack_public_path__ + "img/add-arrival-arrange-climbing-table-icon.783f5965.svg";